<div [ngClass]="{'dark': darkMode}">
    <router-outlet></router-outlet>
</div>
